// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b5b6757e","453":"25dbed1a","455":"315c731c"}[chunkId] + ".chunk.js";
};